import type { EmailTemplate } from "@redotech/redo-model/email-template";
import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import {
  SavedEmailTemplateSource,
  savedEmailTemplateSchema,
} from "@redotech/redo-model/saved-email-template";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createSavedEmailTemplate = {
  name: "createSavedEmailTemplate" as const,
  input: z.object({
    template: emailTemplateSchema as z.ZodType<EmailTemplate>,
    name: z.string(),
    source: createEnum(SavedEmailTemplateSource),
    isGenerating: z.boolean().optional(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
